"use strict";
exports.black = '#000';
exports.blue = '#1A95D3';
exports.green = '#00C853';
exports.grey = '#CBCBCB';
exports.greyTransparent = 'rgba(50, 50, 50, 0.5)';
exports.red = '#F93943';
exports.white = '#FFF';
exports.whiteTransparent = 'rgba(0, 0, 0, 0.5)';
exports.transparent = 'transparent';



/** WEBPACK FOOTER **
 ** ./src/components/theme/colors.ts
 **/